import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Registrations',
  basePath: '/reg',
  columns: [
    { key: 'reg_id', label: 'ID', sortable: true },
    { key: 'reg_name', label: 'Name', sortable: true },
    { key: 'reg_phone', label: 'Phone', sortable: true },
    { key: 'reg_email', label: 'Email', sortable: true },
    { key: 'region_name', label: 'Region', sortable: true },
    { key: 'companytype_names', label: 'Sectors' },
    { key: 'reg_level_description', label: 'Level', sortable: true },
    { key: 'business_owner', label: 'Business Owner', sortable: true,
      render: (v) => {
        if (v == 1) return 'Yes';
        if (v == 2) return 'No';
        return 'N/A';
      } },
  ],
  fields: [
    { key: 'reg_name', label: 'Reg name', type: 'text' },
    { key: 'reg_address', label: 'Reg address', type: 'text' },
    { key: 'reg_phone', label: 'Reg phone', type: 'text' },
    { key: 'reg_email', label: 'Reg email', type: 'text' },
    { key: 'reg_age', label: 'Reg age', type: 'text' },
    { key: 'reg_exp1', label: 'Reg exp1', type: 'text' },
    { key: 'reg_exp2', label: 'Reg exp2', type: 'text' },
    { key: 'reg_exp3', label: 'Reg exp3', type: 'text' },
    { key: 'reg_edu', label: 'Reg edu', type: 'text' },
    { key: 'reg_pref1', label: 'Reg pref1', type: 'text' },
    { key: 'reg_pref2', label: 'Reg pref2', type: 'text' },
    { key: 'reg_cv', label: 'Reg cv', type: 'text' },
    { key: 'reg_idea', label: 'Reg idea', type: 'text' },
    { key: 'reg_woj', label: 'Reg woj', type: 'text' },
    { key: 'reg_inv', label: 'Reg inv', type: 'text' },
    { key: 'business_owner', label: 'Business owner', type: 'text' },
  ],
  filters: [
    { key: 'email', label: 'Email', type: 'text' },
    { key: 'name', label: 'Name', type: 'text' },
    { key: 'regLevel', label: 'Investment Level', type: 'multiselect',
      optionsUrl: '/reg-levels/options' },
    { key: 'sectors', label: 'Sector', type: 'multiselect',
      optionsUrl: '/company-types/options' },
    { key: 'regions', label: 'Region', type: 'multiselect',
      optionsUrl: '/regions/options' },
    { key: 'owner', label: 'Business Owner', type: 'radio',
      options: [
        { value: '', label: 'All' },
        { value: '1', label: 'Yes' },
        { value: '2', label: 'No' },
        { value: '0', label: 'N/A' },
      ] },
  ],
  rowActions: [
    { key: 'delete', label: 'Delete', variant: 'danger',
      confirm: 'Are you sure you want to remove this row?' },
  ],
  rowKey: 'reg_id',
  defaultSort: { field: 'reg_id', dir: 'desc' },
});
